<template>
    <b-form-group
        :state="state"
        labelClass="label"
        :label="$t('form.label.admittedToDate')"
    >
        <div class="d-flex">
            <v-date-picker
                v-model="model"
                class="date-picker"
                popoverDirection="top"
                nav-visibility="click"
                :popover="{ visibility: 'click' }"
            >
                <template v-slot="{ inputValue, inputEvents }">
                    <b-form-input
                        readonly
                        class="input"
                        :state="state"
                        v-on="inputEvents"
                        :value="inputValue"
                        placeholder="## / ## / ####"
                    />
                </template>
            </v-date-picker>
            <b-button size="sm" variant="danger" @click="model = null">
                <i class="fas fa-trash" />
            </b-button>
        </div>
    </b-form-group>
</template>
<script>
import { DatePicker as VDatePicker } from 'v-calendar'
export default {
    components: {
        VDatePicker,
    },
    props: {
        value: Date,
        state: Boolean,
    },
    computed: {
        model: {
            set(newValue) {
                this.$emit('update:value', newValue)
            },
            get() {
                return this.value
            },
        },
    },
}
</script>
<style scoped>
.date-picker {
    width: 100%;
    margin-right: 1px;
}

.input {
    background-color: white;
}
</style>
